import { AnalyticsController } from '../../layout/Analytics';
import { CardTrioInputs } from './CardTrio';
import { CardTrioCard } from './CardTrioCard';

export const articleCardTrioTransformer = (node): CardTrioInputs => {
    const cardInputs = node.relationships?.field_articles_trio
        ? node.relationships?.field_articles_trio
        : node.relationships?.field_article_trio;
    const cards = generateArticleTrioCards(
        cardInputs,
        false,
        node.field_component_title
            ? node.field_component_title
            : node.field_title
    );

    return {
        id: node.id,
        header: node.field_component_title
            ? node.field_component_title
            : node.field_title,
        cards,
        cta: node.relationships?.field_view_all_news_category
            ? {
                  uri: node.relationships.field_view_all_news_category.path
                      ?.alias,
                  title: `View All`,
              }
            : undefined,
    };
};

export const generateArticleTrioCards = (
    cardNodes,
    showDates?: boolean,
    title?: string
) => {
    const cards: CardTrioCard[] = [];
    if (!cardNodes) return cards;

    for (const article of cardNodes) {
        const card: CardTrioCard = {
            id: article.id,
            news: true,
            linkText: `Read this article`,
            linkUrl: article.fields?.url,
            title: article.title,
            date: article.field_news_date,
            eyebrow: article.relationships.field_news_category?.name,
            imageAlt:
                article.relationships?.field_alternate_image?.field_media_image
                    ?.alt ??
                article.relationships.field_news_image?.field_media_image_1
                    ?.alt,
            image:
                article.relationships.field_alternate_image?.relationships
                    ?.field_media_image.localFile ??
                article.relationships.field_news_image?.relationships
                    ?.field_media_image_1?.localFile.childImageSharp
                    .gatsbyImageData,
            onClick: () => {
                AnalyticsController.track({
                    event: `component click`,
                    componentLink: `${title}: ${article.title}`,
                });
            },
        };

        if (showDates) {
            card.date = article.field_news_date;
        }

        if (!card.image) {
            card.description = article.field_summary;
        }

        cards.push(card);
    }

    return cards;
};
